"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZodTransformer = void 0;
var ZodTypes_1 = require("../ZodTypes");
var base_1 = require("./base");
var ZodTransformer = (function (_super) {
    __extends(ZodTransformer, _super);
    function ZodTransformer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.toJSON = function () { return ({
            t: _this._def.t,
            left: _this._def.input.toJSON(),
            right: _this._def.output.toJSON(),
        }); };
        return _this;
    }
    Object.defineProperty(ZodTransformer.prototype, "output", {
        get: function () {
            return this._def.output;
        },
        enumerable: false,
        configurable: true
    });
    ZodTransformer.create = function (input, output, transformer) {
        return new ZodTransformer({
            t: ZodTypes_1.ZodTypes.transformer,
            input: input,
            output: output,
            transformer: transformer,
        });
    };
    ZodTransformer.fromSchema = function (input) {
        return new ZodTransformer({
            t: ZodTypes_1.ZodTypes.transformer,
            input: input,
            output: input,
            transformer: function (x) { return x; },
        });
    };
    return ZodTransformer;
}(base_1.ZodType));
exports.ZodTransformer = ZodTransformer;
//# sourceMappingURL=transformer.js.map